import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createBikeCalculatorForm(): FormGroup<BikeCalculatorFormModel> {
  return new FormGroup<BikeCalculatorFormModel>({
    isEbike: new FormControl<null | boolean>(null, [Validators.required]),
    price: new FormControl<null | number>(null, [Validators.required, Validators.min(0), Validators.max(15000)])
  });
}

export interface BikeCalculatorFormModel {
  isEbike: FormControl<null | boolean>;
  price: FormControl<null | number>;
}
